import { UniFiCategoryId } from "@ubnt/store.core/lib/constants/proStoreCategories/mapping/unifi";

import { SiteId } from "@ubnt/store.core/lib/contexts/MenuContext/mapping";
import image from "../../assets/wifi/enterprise/e7-campus.png";
import type { Product } from "../../types";
import { wifiE7 } from "../product-list-groups/wifi-e7";
import {
  antennaType,
  connectedDevices,
  dedicatedSpectral,
  extendedRangeMode6Ghz,
  fipsCompliance,
  powerMethodPoe,
  radio6Ghz,
  redundantRj45Port,
  rfFilteringTechnology,
  uplink,
  weatherproofing,
  wifiCoverage,
  wifiMounting,
  wifiTechnology,
} from "../properties";

export const e7Campus: Product = {
  id: "e7Campus",
  productTitle: "E7 Campus",
  isNew: true,
  techspecsPath: [
    SiteId.TechSpecs,
    `/unifi/${UniFiCategoryId.WiFi}/e7-campus-us`,
  ],
  storePathParts: { productSlug: "e7-campus-us", category: "wifi-enterprise" },
  sku: "E7-Campus",
  description: "e7Campus.description",
  image: { src: image, width: 200, height: 160 },
  productListGroup: wifiE7,
  propertyValues: [
    {
      propertyId: "dimensions",
      value: {
        type: "string",
        value:
          'Device: 250 x 250 x 45.5 mm\n(9.8 x 9.8 x 1.8")\n\n\nArticulating mount: Ø104 x 149.4\n(Ø4.1 x 5.9")',
      },
    },
    {
      propertyId: wifiTechnology.id,
      value: {
        type: "translation",
        value: "e7Campus.wifiTechnology",
      },
    },
    {
      propertyId: radio6Ghz.id,
      value: { type: "boolean", value: true },
    },
    {
      propertyId: extendedRangeMode6Ghz.id,
      value: { type: "boolean", value: true, asterisk: 1 },
    },
    {
      propertyId: dedicatedSpectral.id,
      value: { type: "boolean", value: true },
    },
    {
      propertyId: rfFilteringTechnology.id,
      value: { type: "boolean", value: true },
    },
    {
      propertyId: antennaType.id,
      value: {
        type: "translation",
        value: "antennaType.directional",
      },
    },
    {
      propertyId: wifiCoverage.id,
      value: {
        type: "translation",
        value: "e7Campus.wifiCoverage",
      },
    },
    {
      propertyId: connectedDevices.id,
      value: { type: "string", value: "1,000+" },
    },
    {
      propertyId: weatherproofing.id,
      value: { type: "string", value: "IP67" },
    },
    {
      propertyId: powerMethodPoe.id,
      value: { type: "string", value: "PoE++" },
    },
    {
      propertyId: uplink.id,
      value: { type: "string", value: "10 GbE" },
    },
    {
      propertyId: redundantRj45Port.id,
      value: { type: "boolean", value: true },
    },
    {
      propertyId: wifiMounting.id,
      value: {
        type: "translation",
        value: "e7Campus.mounting",
      },
    },
    {
      propertyId: fipsCompliance.id,
      value: { type: "boolean", value: true, asterisk: 4 },
    },
  ],
  notes: ["e7Campus.note.1"],
};
